(window as any).global = window;
(window as any).process = {
	env: { DEBUG: undefined },
};

type PromiseWithPolyfills = typeof Promise & {
	try?: <T>(fn: (...args: unknown[]) => T | PromiseLike<T>, ...args: unknown[]) => Promise<T>;
	withResolvers?: <T>() => {
		promise: Promise<T>;
		resolve: (value: T | PromiseLike<T>) => void;
		reject: (reason?: unknown) => void;
	};
};

const promiseCtor = Promise as PromiseWithPolyfills;

if (typeof promiseCtor.try !== 'function') {
	promiseCtor.try = <T>(fn: (...args: unknown[]) => T | PromiseLike<T>, ...args: unknown[]): Promise<T> =>
		new Promise((resolve, reject) => {
			try {
				resolve(fn(...args));
			} catch (error) {
				reject(error);
			}
		});
}

if (typeof promiseCtor.withResolvers !== 'function') {
	promiseCtor.withResolvers = <T>() => {
		let resolve!: (value: T | PromiseLike<T>) => void;
		let reject!: (reason?: unknown) => void;
		const promise = new Promise<T>((res, rej) => {
			resolve = res;
			reject = rej;
		});
		return { promise, resolve, reject };
	};
}
/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * The current setup targets evergreen browsers (ES2022).
 * Learn more in https://angular.io/guide/browser-support
 */

/***************************************************************************************************
 * Zone JS is required by default for Angular itself.
 */
import 'zone.js';
import '../node_modules/hammerjs/hammer.js';
